import Media from './../mediaDetect.js'; //Детектор медиа

let Main = {
  initMainSlider: function(slider){
    slider.slick({
      adaptiveHeight: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      pauseOnHover: false,
      pauseOnFocus: false,
      autoplay: true,
      autoplaySpeed: 8000,
      speed: 800,
      fade: true,
      arrows: true,
      dots: true,
      responsive: [
          {
              breakpoint: 768,
              settings: {
                  adaptiveHeight: true,
                  arrows: false
              }
          }
      ]
    });
  },
  pauseMainSlider: function(slider){
    slider.slick('slickPause');
  },
  playMainSlider: function(slider){
    slider.slick('slickPlay');
  }
}

$(document).ready(function($) {
  
  let mainSlider = $('[data-main-slider]');
  if(mainSlider.length && !mainSlider.hasClass('slick-initialized')){
    Main.initMainSlider(mainSlider);
  }

});

export default {
  pauseMainSlider: Main.pauseMainSlider,
  playMainSlider: Main.playMainSlider
};


// WEBPACK FOOTER //
// ./components/main.js